var React = require( 'react' );
var createReactClass = require('create-react-class');
var ContentListItem = require('./contentListItem.jsx');

var ContentList = createReactClass({

    render: function(){
        var contentListItemNodes = this.props.contentList.map(function(content, i){
            return <ContentListItem content={content} key={i} />;
        });

        return (
            <ul className="content-list no-bullet">
                {contentListItemNodes}
            </ul>
        );
    }
});

module.exports = ContentList;



// WEBPACK FOOTER //
// ./src/common/routes/faqs/components/layout/contentList.jsx